import { Component, OnInit } from '@angular/core';
import { CasesService, listUserCaseOutput } from './service/cases.service';
import { Observable, of } from 'rxjs';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-cases',
  templateUrl: './cases.component.html',
  styleUrls: ['./cases.component.scss'],
})
export class CasesComponent implements OnInit {
  selectedTab: number = 0;
  userCredits: string;
  stateAndCities: Record<string, string[]>;
  states: string[] = [];
  cities: string[] = [];

  stateControl = new FormControl(null);
  selectedCity = '';
  filteredCities$: Observable<string[]> = of([]);
  hasFilterOn: boolean = false;

  constructor(
    private readonly service: CasesService,
    private readonly snack: MatSnackBar
  ) {}

  loading = false;

  allCases: listUserCaseOutput[];
  page: number = 1;
  pageLength: number = 10;
  totalRows: number = 0;

  ngOnInit(): void {
    this.getUserCredits();
    this.listStatesAndCity();

    this.listAllCases(this.page, {
      state: this.stateControl.value,
      city: this.selectedCity,
    });
  }

  paginationChange(page: number) {
    this.listAllCases(page, {
      state: this.stateControl.value,
      city: this.selectedCity,
    });
  }

  acquireCase(caseId: number) {
    const caseDetail = this.allCases.find((item) => item.id === caseId);

    if (!caseDetail) {
      this.snack.open(
        `Não foi possível adquirir essa oportunidade. Tente novamente mais tarde.`,
        'OK',
        { duration: 3000 }
      );

      this.removeFilters();
    }

    this.service
      .acquireCaseWithCredits(caseId)
      .pipe(
        tap(() => {
          this.changeTab(1);
        })
      )
      .subscribe({
        error: (err) => {
          this.snack.open(err.error.message, 'OK', { duration: 2000 });
        },
      });
  }

  private listAllCases(
    page: number,
    filters?: { state?: string; city?: string }
  ) {
    this.loading = true;

    const pagination = {
      page,
      perPage: this.pageLength,
      state: filters.state,
      city: filters.city,
    };

    this.service.listAllCases(pagination).subscribe({
      next: ({ data, total }) => {
        this.allCases = data;
        this.totalRows = total;

        this.allCases.forEach((item) => {
          const { patientCity: city, patientState: state } = item;

          item.totalAcquired = item.totalAcquired > 3 ? 3 : item.totalAcquired;

          item.cityStateText =
            city && state ? `${city} - ${state}` : city || state || '-';

          const situacaoSocial = item.isBpc
            ? 'Cliente está em situação de vulnerabilidade'
            : item.isBpc === null
            ? 'Não se aplica'
            : 'Não está em situação de vunerabilidade';

          const cadUnico = item.isBpc
            ? item.isCadUnico
              ? '/ Cliente está inscrito no CadÚnico'
              : item.isCadUnico === null
              ? '/ Cliente não sabe informar se participa do CadÚnico'
              : '/ Cliente não está cadastrado no CadÚnico'
            : '';

          const text = `<span>
            ${situacaoSocial} <br /> ${cadUnico}
          </span>`;
          item.bpcText = text;
        });
        this.loading = false;
      },
    });
  }

  changeTab(index: number): void {
    this.selectedTab = index;
    this.getUserCredits();
  }

  filterStateListener(uf: string): void {
    this.cities = this.stateAndCities[uf] || [];
    this.selectedCity = '';
    this.filteredCities$ = of(this.cities);
  }

  filterCityListener(city: string): void {
    this.selectedCity = city;
  }

  cityInputListener(value: string): void {
    this.filteredCities$ = of(
      this.cities.filter((city) =>
        city.toLocaleLowerCase().includes(value.toLocaleLowerCase())
      )
    );
  }

  validateCityInput(): void {
    if (this.selectedCity && !this.cities.includes(this.selectedCity)) {
      this.selectedCity = '';
      this.filteredCities$ = of(this.cities);
    }
  }

  applyFilter(): void {
    this.page = 1;
    this.hasFilterOn = true;

    this.listAllCases(this.page, {
      state: this.stateControl.value,
      city: this.selectedCity,
    });
  }

  removeFilters(): void {
    this.hasFilterOn = false;
    this.stateControl.reset();
    this.selectedCity = '';
    this.cities = [];
    this.page = 1;

    this.listAllCases(this.page, {
      state: this.stateControl.value,
      city: this.selectedCity,
    });
  }

  private listStatesAndCity(): void {
    this.service.listStatesAndCity().subscribe({
      next: (response) => {
        this.stateAndCities = response;
        this.states = Object.keys(response);
      },
      error: (err) => {
        console.log('Erro ao listar estados e cidade', err.error.message);
      },
    });
  }

  private getUserCredits(): void {
    this.service.getUserCredits().subscribe({
      next: (response) => {
        this.userCredits = `✅ Créditos disponíveis: ${response} atendimentos restantes este mês.`;
      },
      error: (err) => {
        console.log('Erro ao buscar dados do usuário:', err);
      },
    });
  }
}
